export enum UserFields {
  USERNAME = "username",
  EMAIL = "email",
  PHONE = "phone",
  PASSWORD = "password",
  FIRST_NAME = "first_name",
  LAST_NAME = "last_name",
  PROP_ID = "prop_id",
}

export enum UserRoles {
  ROLE_CUSTOMER = "ROLE_CUSTOMER",
  ROLE_PROPERTY_MANAGER = "ROLE_PROPERTY_MANAGER",
  ROLE_PORTFOLIO_MANAGER = "ROLE_PORTFOLIO_MANAGER",
  ROLE_PORTFOLIO_ADMIN = "ROLE_PORTFOLIO_ADMIN",
  ROLE_SUPPORT_USER = "ROLE_SUPPORT_USER",
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_LOAN_SUPPORT = "ROLE_LOAN_SUPPORT",
}

export enum PasswordFields {
  CURRENT_PASSWORD = "currentPassword",
  NEW_PASSWORD = "newPassword",
  CONFIRM_NEW_PASSWORD = "confirmNewPassword",
}
